export const UPLOAD_BANNER = 'UPLOAD_BANNER';
export const UPLOAD_IMAGE_OUTSTANSDING = 'UPLOAD_IMAGE_OUTSTANSDING';
export const UPLOAD_IMAGE_AUDITION = 'UPLOAD_IMAGE_AUDITION';
export const UPLOAD_IMAGE_SCHEDULE = 'UPLOAD_IMAGE_SCHEDULE';
export const UPLOAD_WORD_FILE_SUCCESS = "UPLOAD_WORD_FILE_SUCCESS";
